import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { BQLink } from '../../../../atoms/bqlink';
import Loader from '../../../../atoms/icons/loader';
import { widgetLink } from '../../../../../helpers/utils';
import { ChevronLeftIcon } from '../../../../atoms/material-icons';
import EmptyState from '../empty-state';
import SectoralSearchIndices from './sectoral-search-stocks';
import './sectoral-stocks-in-indices-external-widget.m.css';

const SectoralStocksInIndicesExternalWidget = ({ widget = false }) => {
  const widgetParam = widget ? '?view=apps' : '';
  const [indice, setIndice] = useState('');
  const [stocksIndicesData, setStocksIndicesData] = useState([]);
  const [selectedIndiceKey, setSelectedIndiceKey] = useState('');
  const [selectedDuration, setSelectedDuration] = useState('');
  const [initialLoading, setInitialLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [oneD, setOneD] = useState(false);
  const [oneW, setOneW] = useState(false);
  const [oneM, setOneM] = useState(false);
  const [oneYTD, setOneYTD] = useState(false);
  const [oneY, setOneY] = useState(false);
  const [threeY, setThreeY] = useState(false);

  const getSectoralStocksInIndicesData = async (key = '127', duration = '1D') => {
    const response = await fetch(`/feapi/markets/external/indices/${key}/${duration}`);
    return response.json();
  };

  const resultSectoralStocksInIndicesData = useQuery(
    'getSectoralStocksInIndicesData',
    () => getSectoralStocksInIndicesData(selectedIndiceKey, selectedDuration),
    {
      refetchInterval: 30000,
      refetchIntervalInBackground: true,
      onSuccess: (data) => {
        setStocksIndicesData(data.data);
      },
      enabled: !!selectedIndiceKey && !!selectedDuration,
    },
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setIndice('BANKNIFTY');
    setSelectedIndiceKey('127');
  }, []);

  useEffect(() => {
    const getSectoralStocksInIndicesData = async () => {
      setLoading(true);
      const response = await fetch('/feapi/markets/external/indices/127/1D');
      const data = await response.json();
      setLoading(false);
      setStocksIndicesData(data?.data);
    };

    getSectoralStocksInIndicesData();
  }, []);

  useEffect(() => {
    setSelectedDuration('1D');
    setSelectedIndiceKey('127');
    if (resultSectoralStocksInIndicesData?.isSuccess) {
      setStocksIndicesData(resultSectoralStocksInIndicesData?.data?.data);
    }
    setOneD(true);
    setOneW(false);
    setOneM(false);
    setOneYTD(false);
    setOneY(false);
    setThreeY(false);
  }, []);

  const stockSearchHandler = async (indiceName, indiceKey) => {
    setIndice(indiceName);
    setSelectedIndiceKey(indiceKey);
    setSelectedDuration('1D');
    setLoading(true);
    const response = await fetch(`/feapi/markets/external/indices/${indiceKey}/1D`);
    const data = await response.json();
    setLoading(false);
    setStocksIndicesData(data?.data);
    setOneD(true);
    setOneW(false);
    setOneM(false);
    setOneYTD(false);
    setOneY(false);
    setThreeY(false);
  };

  const durationHandler = async (indiceKey, duration) => {
    setLoading(true);
    const response = await fetch(`/feapi/markets/external/indices/${indiceKey}/${duration}`);
    const data = await response.json();
    setStocksIndicesData(data.data);
    setLoading(false);
  };

  if (initialLoading) {
    return <div styleName="initial-loading-container"></div>;
  }

  if (resultSectoralStocksInIndicesData?.isLoading) {
    <div>
      <Loader color={'#dadee1'} />
    </div>;
  }

  return (
    <div styleName="overall-container">
      <div styleName="header-container">
        <div styleName="icon-text-container">
          <BQLink href={widgetLink(`/markets${widgetParam}`, widget)} styleName="header-btn">
            <ChevronLeftIcon color="#8F9DA5" size={'25px'} />
          </BQLink>
          <h1 styleName="header-text">{indice}</h1>
        </div>

        <div styleName="search-btn-container">
          <div styleName="btn-container">
            <button
              styleName={`indice-btn ${oneD ? 'selected' : ' '}`}
              onClick={() => {
                durationHandler(selectedIndiceKey, '1D');
                setSelectedDuration('1D');
                setOneD(true);
                setOneW(false);
                setOneM(false);
                setOneYTD(false);
                setOneY(false);
                setThreeY(false);
              }}
            >
              1D
            </button>
            <button
              styleName={`indice-btn ${oneW ? 'selected' : ' '}`}
              onClick={() => {
                durationHandler(selectedIndiceKey, '1W');
                setSelectedDuration('1W');
                setOneD(false);
                setOneW(true);
                setOneM(false);
                setOneYTD(false);
                setOneY(false);
                setThreeY(false);
              }}
            >
              1W
            </button>
            <button
              styleName={`indice-btn ${oneM ? 'selected' : ' '}`}
              onClick={() => {
                durationHandler(selectedIndiceKey, '1M');
                setSelectedDuration('1M');
                setOneD(false);
                setOneW(false);
                setOneM(true);
                setOneYTD(false);
                setOneY(false);
                setThreeY(false);
              }}
            >
              1M
            </button>
            <button
              styleName={`indice-btn ${oneYTD ? 'selected' : ' '}`}
              onClick={() => {
                durationHandler(selectedIndiceKey, 'YTD');
                setSelectedDuration('YTD');
                setOneD(false);
                setOneW(false);
                setOneM(false);
                setOneYTD(true);
                setOneY(false);
                setThreeY(false);
              }}
            >
              YTD
            </button>
            <button
              styleName={`indice-btn ${oneY ? 'selected' : ' '}`}
              onClick={() => {
                durationHandler(selectedIndiceKey, '1Y');
                setSelectedDuration('1Y');
                setOneD(false);
                setOneW(false);
                setOneM(false);
                setOneYTD(false);
                setOneY(true);
                setThreeY(false);
              }}
            >
              1Y
            </button>
            <button
              styleName={`indice-btn ${threeY ? 'selected' : ' '}`}
              onClick={() => {
                durationHandler(selectedIndiceKey, '3Y');
                setSelectedDuration('3Y');
                setOneD(false);
                setOneW(false);
                setOneM(false);
                setOneYTD(false);
                setOneY(false);
                setThreeY(true);
              }}
            >
              3Y
            </button>
          </div>

          <div styleName="search-box">
            <SectoralSearchIndices onStockSearch={stockSearchHandler} />
          </div>
        </div>
      </div>
      <div styleName="content-container">
        <div styleName="table-container">
          {stocksIndicesData && stocksIndicesData?.length > 0 ? (
            <>
              {loading ? (
                <div styleName="no-data-container-ext">
                  <div styleName="no-data-container-int">
                    <Loader color={'#dadee1'} />
                  </div>
                </div>
              ) : (
                <>
                  {' '}
                  <div styleName="table-body-container">
                    <table styleName="main-table">
                      <thead styleName="table-header">
                        <tr>
                          <th styleName="column-title">STOCKS</th>
                          <th styleName="column-title-alt">CURRENT PRICE</th>
                          <th styleName="column-title-alt">CHANGE(RS)</th>
                          <th styleName="column-title-alt">CHANGE(%)</th>
                          {selectedDuration === '1D' && (
                            <th styleName="column-title-alt">DAY&apos;S HIGH</th>
                          )}
                          {selectedDuration === '1D' && (
                            <th styleName="column-title-alt">DAY&apos;S LOW</th>
                          )}
                          {selectedDuration !== '1D' && (
                            <th styleName="column-title-alt">52 WEEK HIGH</th>
                          )}
                          {selectedDuration !== '1D' && (
                            <th styleName="column-title-alt">52 WEEK LOW</th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {stocksIndicesData &&
                          stocksIndicesData?.map((indiceValue, index) => (
                            <tr key={indiceValue?.id} styleName={`data-row `}>
                              <td>
                                {indiceValue?.name ? (
                                  <BQLink
                                    href={widgetLink(
                                      `/stock/${indiceValue.id}/${indiceValue?.name
                                        ?.toLowerCase()
                                        .trim()
                                        .replaceAll(' ', '-')
                                        .split('-')
                                        .filter((val) => val !== '')
                                        .map((val) => val.replaceAll('.', ''))
                                        .join('-')}${widgetParam}`,
                                      widget,
                                    )}
                                    target="_blank"
                                  >
                                    <span styleName="name">{indiceValue?.name}</span>
                                  </BQLink>
                                ) : (
                                  <span styleName="name">-</span>
                                )}
                              </td>
                              <td styleName="column-value">
                                {indiceValue['price-movement']?.['current-price'] ? (
                                  <span styleName="current-price">
                                    {indiceValue['price-movement']?.['current-price']}
                                  </span>
                                ) : (
                                  <span styleName="current-price">-</span>
                                )}
                              </td>
                              <td styleName="column-value">
                                {indiceValue['price-movement']?.['chg'] ? (
                                  <span>
                                    {String(indiceValue['price-movement']?.['chg']).includes(
                                      '-',
                                    ) ? (
                                      <span styleName="negative-value">
                                        {indiceValue['price-movement']?.['chg']}
                                      </span>
                                    ) : (
                                      <span styleName="positive-value">
                                        {`+${indiceValue['price-movement']?.['chg']}`}
                                      </span>
                                    )}
                                  </span>
                                ) : (
                                  <span>-</span>
                                )}
                              </td>
                              <td styleName="column-value">
                                {indiceValue['price-movement']?.['chgp'] ? (
                                  <span>
                                    {String(indiceValue['price-movement']?.['chgp']).includes(
                                      '-',
                                    ) ? (
                                      <span styleName="negative-value">
                                        {indiceValue['price-movement']?.['chgp']}
                                      </span>
                                    ) : (
                                      <span styleName="positive-value">
                                        {`+${indiceValue['price-movement']?.['chgp']}`}
                                      </span>
                                    )}
                                  </span>
                                ) : (
                                  <span>-</span>
                                )}
                              </td>
                              {selectedDuration === '1D' && (
                                <td styleName="column-value">
                                  {indiceValue['price-movement']?.['high'] ? (
                                    <span styleName="current-price">
                                      {indiceValue['price-movement']?.['high']}
                                    </span>
                                  ) : (
                                    <span styleName="current-price">-</span>
                                  )}
                                </td>
                              )}
                              {selectedDuration === '1D' && (
                                <td styleName="column-value">
                                  {indiceValue['price-movement']?.['low'] ? (
                                    <span styleName="current-price">
                                      {indiceValue['price-movement']?.['low']}
                                    </span>
                                  ) : (
                                    <span styleName="current-price">-</span>
                                  )}
                                </td>
                              )}
                              {selectedDuration !== '1D' && (
                                <td styleName="column-value">
                                  {indiceValue['price-movement']?.['52wk-high'] ? (
                                    <span styleName="current-price">
                                      {indiceValue['price-movement']?.['52wk-high']}
                                    </span>
                                  ) : (
                                    <span styleName="current-price">-</span>
                                  )}
                                </td>
                              )}
                              {selectedDuration !== '1D' && (
                                <td styleName="column-value">
                                  {indiceValue['price-movement']?.['52wk-low'] ? (
                                    <span styleName="current-price">
                                      {indiceValue['price-movement']?.['52wk-low']}
                                    </span>
                                  ) : (
                                    <span styleName="current-price">-</span>
                                  )}
                                </td>
                              )}
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                  <div styleName="end-container"></div>
                </>
              )}
            </>
          ) : (
            <div styleName="no-data-container-ext">
              <div styleName="no-data-container-int">
                <EmptyState />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SectoralStocksInIndicesExternalWidget;
